import { keyframes, styled } from "styled-components";

interface DashboardTitleContainerProps {
    offset: number;
}

export const IntroTitleContainer = (props: number) => keyframes`
    0%{
        opacity: 0;
        left:0px;
    }
    30%{
        opacity: 0;
        left:0px;
    }
    100%{
        opacity: 1;
        left:${props}px;
    }
`;

export const DashbaordTitleContainer = styled.div<DashboardTitleContainerProps>`
    opacity: 0;
    transition: 1s all ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    height: 25%;
    position: absolute;
    top: 10%;
    animation: ${(props) => IntroTitleContainer(props.offset)}
        ${(props) => props.theme.animationTime.medium}s;
    animation-fill-mode: forwards;
    animation-iteration-count: 1;
    @media screen and (max-width: ${props=>props.theme.breakpoint}){
        flex-direction: row;
    }
`;

export const DashboardTitleText = styled.div`
    font-weight: 600;
    font-size: 50px;
`;

export const DashboardTitleIcon = styled.img`
    width: 100px;
    height: 100px;
    border-radius: 50%;
`;
